/** @format */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, makeStateKey, PLATFORM_ID, TransferState } from '@angular/core';
import { Environment, MyCustomizerMap } from '@shared/data-access/interfaces';

import { Observable, of, tap } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class CustomProductDao {
	constructor(
		private environment: Environment,
		private http: HttpClient,
		@Inject(PLATFORM_ID) protected platformId: object,
		private state: TransferState
	) {}
	/**
	 * @description
	 * Loads customized product attributes
	 *
	 * @param designId - The design ID to get custom attributes for
	 *
	 * @returns Customized product attributes
	 */
	public loadCustomizedProductAttributes$(designId: string): Observable<MyCustomizerMap> {
		const STATE_KEY = makeStateKey<MyCustomizerMap>(`customized-product-${designId}`);

		// Attempt to get the state by key
		const stateData = this.state.get(STATE_KEY, null);
		// Check to see if state exists
		if (stateData) {
			// Return the existing stateviewsByProductId has state data ');
			return of(stateData);
		}

		return this.http
			.get<MyCustomizerMap>(`${this.environment.customizer}/design/${designId}/summary.json`)
			.pipe(
				tap((customAttrs: MyCustomizerMap) => {
					// Set the state
					this.state.set<MyCustomizerMap>(STATE_KEY, customAttrs);
				})
			);
	}
}
